

import React, { Fragment, useState, useEffect } from 'react'
import { Tr, Td, Box, Text, Flex, Icon, FormControl, FormLabel, Switch, useToast, Menu, MenuButton, MenuList, MenuItem } from '@chakra-ui/react'
import { BsThreeDotsVertical } from "react-icons/bs";
// import CampaignWisePerformance from '../../Campaigns/components/CampaignWisePerformance'
import { MdModeEditOutline, MdDelete } from "react-icons/md";
import { QueryClient, useMutation } from "react-query"
// import { toggleFlow, deleteRule } from '../../../Services/api';
import { useNavigate } from "react-router-dom"
import { ConfimrationAlerts } from '../../components/themeComponents/ConfirmationAlert'; 
import { HiOutlineDuplicate } from "react-icons/hi";
import { PiTreeViewLight } from "react-icons/pi";
import { IoMdAnalytics } from 'react-icons/io';
import { TbDeviceDesktopAnalytics } from 'react-icons/tb';
import { deleteExitIntent, toggleExitIntent } from '../../Services/api';
let queryClient = new QueryClient()
export default function ExitIntentTable({ list, refetch }) {
    const toast = useToast();
    const navigate = useNavigate()
    const [flowList, setFlowList] = useState(list)
   
    // const mutation = useMutation(toggleStatus);
    // const [flowList, setFlowList] = useState(list)
    // const handleToggle = async (status, uuid) => {
    //     try {
    //         await mutation.mutateAsync(status, uuid);
    //         // After updating the name, refetch the data to get the updated list
    //         //refetch();
    //     } catch (error) {
    //         console.error('Error updating item name:', error);
    //     }
    // }
    const deleteExitIntentTemplate = (uuid) => {
        ConfimrationAlerts({
            title: "Are you sure?",
            message: `Do you want to delete the template?`,
            okText: 'Okay',
            // confirmColor: 'black',
            async onOk() {
                const examplePromise = new Promise(async (resolve, reject) => {
                    let deleteResponse = await deleteExitIntent(uuid)

                    resolve(deleteResponse)
                    navigate(0)

                })
                toast.promise(examplePromise, {
                    success: { title: `Rule deleted` },
                    error: { title: 'Opps!', description: `Something went wrong while deleting the template` },
                    loading: { title: 'Deleting the rule', description: 'Please wait' },
                })


            },
            onCancel() {
                //formikIntance.setSubmitting(false)
            },
        })
    }
    const toggleStatus = async (uuid, status) => {
        
        try{

            let  toggleResponse = await toggleExitIntent(uuid,status);
            
            if(toggleResponse){
                toast({title:"Success",description:"", status:"success"})
                refetch()

            }
        }catch(e){
            toast({title:"Oops!",description:"Something went wrong", status:"error"})
        }
    }

    
    useState(() => {

        setFlowList(list)
    }, [list])
    return (
        <Fragment>
            
            {
                !!list.length && list.map(item => (
                    <Tr key={item.uuid}>
                        <Td w={'20%'}>
                            <Box>
                                <Text fontSize={'0.8vw'} >{item.name}</Text>
                                
                            </Box>
                        </Td>
                        <Td w={'10%'}>
                            <Text fontSize={'0.8vw'}>{item.createdAt}</Text>
                        </Td>
                        <Td w={'10%'}>
                            <Text fontSize={'0.8vw'}>{item.lastUpdatedAt}</Text>
                        </Td>

                        {/* <Td w={'10%'}>
                            <Text fontSize={'0.8vw'}>{!!JSON.parse(item.status) ? "ENABLED" : "DISABLED"}</Text>
                        </Td> */}
                        {/*<Td w={'35%'}>
                            <CampaignWisePerformance data={item.performance}></CampaignWisePerformance>
                        </Td>
                        <Td w={'10%'}>
                            <Text fontSize={'0.8vw'} >{item.revenue}</Text>
                        </Td>*/}
                        <Td w={'20%'} >
                        
                            <Icon as={MdModeEditOutline} title='Edit' ml={2} boxSize={5} color={"light"} cursor={'pointer'} 
                            onClick={() => navigate("/exit-intent-create/" + item.uuid)}
                            ></Icon>
                                <Switch fontSize={'0.8vw'} ml={2} title={item.status === 'true' ? 'Disable' : 'Enable'} isChecked={!!(item.status === true)} 
                                onChange={(e) => toggleStatus(item.uuid, e.target.checked)}
                                ></Switch>
                        
                            <Icon as={MdDelete} boxSize={5} title='Delete' ml={2} color={"light"} cursor={'pointer'}
                             onClick={() => deleteExitIntentTemplate(item.uuid)}
                             ></Icon>
                            {/* <FormControl display='flex' alignItems='center'> */}
                        
                        
                                {/* <FormLabel fontSize={'0.8vw'} color={'light'} m={0} ml={2}>{item.status === 'true' ? 'Enabled' : 'Disabled'}</FormLabel> */}
                            {/* </FormControl> */}
                        </Td>
                    </Tr>
                ))
            }
        </Fragment>
    )
}
